import React from "react";
import { useSortBy, useTable } from "react-table";

const SimpleTable = ({ columns, data }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  return (
    <table {...getTableProps()} style={{ width: "100%" }} className="display">
      <thead>
        {headerGroups.map((headerGroup, index) => (
          <tr
            {...headerGroup.getHeaderGroupProps()}
            key={`headerGroup-${index}`}
          >
            {headerGroup.headers.map((column, colIndex) => (
              <th
                {...column.getHeaderProps(column.getSortByToggleProps())}
                key={`column-${colIndex}`}
              >
                <div className="th-title relative d-flex align-center">
                  {column.render("Header")}
                  <span className="material-symbols-outlined">
                    {column.isSorted
                      ? column.isSortedDesc
                        ? "arrow_drop_down"
                        : "arrow_drop_up"
                      : ""}
                  </span>
                </div>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.length === 0 ? (
          <tr>
            <td
              colSpan={columns.length}
              style={{ textAlign: "center", padding: "20px" }}
            >
              <div className="no-rec-found d-flex flex-col">
                <img src="/images/no_search.svg" alt="" />
                No Data Available
              </div>
            </td>
          </tr>
        ) : (
          rows.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={`row-${rowIndex}`}>
                {row.cells.map((cell, cellIndex) => {
                  const cellProps =
                    cellIndex === 0 ? { className: "po-nums" } : {};
                  return (
                    <td
                      {...cell.getCellProps(cellProps)}
                      key={`cell-${cellIndex}`}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
};

export default SimpleTable;
